module.exports = __webpack_public_path__ + "img/bannner.16e62e07.png";